import React from "react";
import "../LegalModal.css";

const LegalModal = ({ isOpen, onClose, title, content }) => {
  if (!isOpen) return null;

  return (
    <div className="legal-modal-backdrop" onClick={onClose}>
      <div className="legal-modal-card" onClick={(e) => e.stopPropagation()}>
        <button className="legal-modal-close" onClick={onClose}>×</button>
        <h2 className="legal-modal-title">{title}</h2>
        <div className="legal-modal-content">
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </div>
      </div>
    </div>
  );
};

export default LegalModal;
